import PropTypes from "prop-types"
import { ClipBoardSingle } from "../svgs/SVGS"
import Tooltip from "../Tooltip"

const Paste = ({ icon, onClick, visible, text, tooltipContent }) => {
  return (
    <section
      className={`paste-all ${window.cheqEssential ? "ce-color" : "cc-color"}`}
      onClick={onClick}
    >
      <label
        className={`${window.cheqEssential ? "ce-color-svg" : "cc-color-svg"}`}
      >
        {icon}
      </label>
      <Tooltip
        id="errorTooltip"
        visible={visible}
        className="cc-error tooltip"
        content={tooltipContent}
      />
      <span data-for="errorTooltip">{text}</span>
    </section>
  )
}

Paste.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.element,
  visible: PropTypes.bool,
  tooltipContent: PropTypes.element,
  text: PropTypes.string,
}

Paste.defaultProps = {
  onClick: () => {},
  icon: <ClipBoardSingle />,
  visible: false,
  tooltipContent: (
    <>
      You don’t have
      <br />
      anything copied!
    </>
  ),
  text: "Paste All",
}

export default Paste
